import { jsx as _jsx } from "theme-ui/jsx-runtime";
export const ScreenReaderOnly = ({ children }) => {
    return (_jsx("span", { style: {
            clip: "rect(0 0 0 0)",
            clipPath: "inset(50%)",
            height: "1px",
            overflow: "hidden",
            userSelect: "none",
            position: "absolute",
            whiteSpace: "nowrap",
            width: "1px"
        }, children: children }));
};
//# sourceMappingURL=ScreenReaderOnly.js.map